var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container",attrs:{"id":"c_modal"}},[_c('a-modal',{attrs:{"title":_vm.title,"visible":_vm.visible,"mask":_vm.mask,"okText":_vm.okText},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }